import { cn } from '@/utils/utils_client';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import * as React from 'react';
import { forwardRef } from 'react';

interface Props extends React.ComponentPropsWithoutRef<typeof DropdownMenuPrimitive.Separator> {
  className?: string;
}

export const UI_PRIMITIVE__dropdown_menu_separator = forwardRef<React.ElementRef<typeof DropdownMenuPrimitive.Separator>, Props>(
  ({ className, ...props }, ref) => (
    <DropdownMenuPrimitive.Separator ref={ref} className={cn('-mx-1 my-1 h-px bg-neutral-100 dark:bg-neutral-800', className)} {...props} />
  ),
);

UI_PRIMITIVE__dropdown_menu_separator.displayName = DropdownMenuPrimitive.Separator.displayName;
